/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Downgrade_Cancel_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to cancel downgrade." |
*
* @param {Plan_Tab_Downgrade_Cancel_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_cancel_error = /** @type {((inputs?: Plan_Tab_Downgrade_Cancel_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_Cancel_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Downgrade konnte nicht abgebrochen werden.")
	return /** @type {LocalizedString} */ ("Failed to cancel downgrade.")
});